/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Publish_Desc7Inputs */

const en_svc_ai_image_pod_automation_publish_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push to Printify, Printful, Shopify and Etsy with one approval step.`)
};

const ar_svc_ai_image_pod_automation_publish_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انشر إلى Printify وPrintful وShopify وEtsy بخطوة موافقة واحدة.`)
};

const bn_svc_ai_image_pod_automation_publish_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এক অনুমোদনে Printify, Printful, Shopify আর Etsy-তে পাঠান।`)
};

const de_svc_ai_image_pod_automation_publish_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push zu Printify, Printful, Shopify und Etsy mit einem Freigabeschritt.`)
};

const es_svc_ai_image_pod_automation_publish_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar en Printify, Printful, Shopify y Etsy con un solo paso de aprobación.`)
};

const fr_svc_ai_image_pod_automation_publish_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publiez vers Printify, Printful, Shopify et Etsy en une seule étape de validation.`)
};

const pt_svc_ai_image_pod_automation_publish_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publique em Printify, Printful, Shopify e Etsy com um só passo de aprovação.`)
};

const zh_svc_ai_image_pod_automation_publish_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一次审核，推送到 Printify、Printful、Shopify 和 Etsy。`)
};

const tr_svc_ai_image_pod_automation_publish_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tek onay adımıyla Printify, Printful, Shopify ve Etsy üzerine itin.`)
};

const ru_svc_ai_image_pod_automation_publish_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пуш в Printify, Printful, Shopify и Etsy в один шаг аппрува.`)
};

const pl_svc_ai_image_pod_automation_publish_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Publish_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push do Printify, Printful, Shopify i Etsy jednym krokiem akceptacji.`)
};

/**
* | output |
* | --- |
* | "Push to Printify, Printful, Shopify and Etsy with one approval step." |
*
* @param {Svc_Ai_Image_Pod_Automation_Publish_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_publish_desc7 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Publish_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Publish_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_publish_desc7(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_publish_desc7(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_publish_desc7(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_publish_desc7(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_publish_desc7(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_publish_desc7(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_publish_desc7(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_publish_desc7(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_publish_desc7(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_publish_desc7(inputs)
	return en_svc_ai_image_pod_automation_publish_desc7(inputs)
});
export { svc_ai_image_pod_automation_publish_desc7 as "svc_ai-image-pod-automation_PUBLISH_desc" }